import script from "./PosLeftbarPrescription.vue?vue&type=script&setup=true&lang=js"
export * from "./PosLeftbarPrescription.vue?vue&type=script&setup=true&lang=js"

import "./PosLeftbarPrescription.vue?vue&type=style&index=0&id=122f295a&scoped=true&lang=css"
import "./PosLeftbarPrescription.vue?vue&type=style&index=1&id=122f295a&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-122f295a"]])

export default __exports__